import Nav from '../components/Nav';
import {
  Box,
  Button,
  Container,
  Divider,
  Flex,
  Heading,
  Text
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import { format } from 'date-fns';
import ArrowRight from '../icons/ArrowRight';
import ChevronRight from '../icons/ChevronRight';
import Transaction from '../components/Transaction';
import { gql, useQuery } from '@apollo/client';

const GET_SUBSCRIPTIONS_QUERY = gql`
query GetSubscription($limit: Int, $partyId: uuid) {
  subscriptions(where: { party_id: { _eq: $partyId } }) {
    id
    party_id
    created_at
    subscription_payment_transactions(
      limit: $limit
      order_by: { created_at: desc }
    ) {
      id
      amount
      created_at
      product_item {
        id
        name
      }
    }
  }
}
`;

const Root = () => {
  const { data, loading } = useQuery(GET_SUBSCRIPTIONS_QUERY, {
    variables: {
      partyId: 'e140d222-d151-11ec-ad5c-877dd6dd5ce5',
      limit: 5
    }
  });

  return (
    <>
      <Nav />

      <Container pl={5} pr={4} py={3} mt={3}>
        <Box>
          <Text fontSize='xl' fontWeight='bold' mb={2} color='#172554'>
            Welcome back, Joram 👋
          </Text>
          <Text fontSize='sm' color='#64748b'>
            Have an in depth look of your metrics in your dashboard
          </Text>

          <Box
            // maxW='sm'
            borderRadius='2xl'
            overflow='hidden'
            background='#2563eb'
            mt={8}
          >
            <Box p={3} mb={3}>
              <Text fontSize='md' color='#ffffff'>
                Amount Borrowed
              </Text>
            </Box>

            <Box px={4}>
              <Text fontSize='sm' fontWeight='medium' color='#fff'>
                KES
              </Text>
              <Text fontSize='4xl' fontWeight='bold' color='#fff' mb={2}>
                {numeral(34500).format('0.0a')}
              </Text>

              <Progress />
              <Flex align='center' justify='space-between' py={2} mt={1}>
                <Text fontSize='sm' color='#fff'>
                  23%
                </Text>
                <Text fontSize='sm' color='#fff'>
                  77%
                </Text>
              </Flex>
            </Box>

            <Divider mt={3} />
            <Box py={3} px={4}>
              <Flex align='center' justify='space-between' mb={3}>
                <Text fontSize='sm' fontWeight='medium' color='#fff'>
                  Available
                </Text>
                <Text fontSize='sm' fontWeight='medium' color='#fff'>
                  Ksh. {numeral(106000).format('0,0')}
                </Text>
              </Flex>
              <Flex align='center' justify='space-between' mb={3}>
                <Text fontSize='sm' fontWeight='medium' color='#fff'>
                  Borrowed
                </Text>
                <Text fontSize='sm' fontWeight='medium' color='#fff'>
                  Ksh. {numeral(34000).format('0,0')}
                </Text>
              </Flex>
              <Flex align='center' justify='space-between' mb={3}>
                <Text fontSize='sm' fontWeight='medium' color='#fff'>
                  Your Limit
                </Text>
                <Text fontSize='sm' fontWeight='medium' color='#fff'>
                  Ksh. {numeral(140000).format('0,0')}
                </Text>
              </Flex>
              <Flex align='center' justify='space-between'>
                <Text fontSize='sm' fontWeight='medium' color='#fff'>
                  Last Payment
                </Text>
                <Text fontSize='sm' fontWeight='medium' color='#fff'>
                  {format(new Date(), 'MMM d, yyyy')}
                </Text>
              </Flex>
            </Box>

            <Divider />

            <Flex justify='center' py={5}>
              <Button
                style={{ color: '#fff', textTransform: 'uppercase' }}
                variant='link'
                fontSize='sm'
                rightIcon={<ChevronRight boxSize='18px' />}
                iconSpacing={4}
              >
                Make Payment
              </Button>
            </Flex>
          </Box>
        </Box>

        <Flex alignItems='center' justify='space-between' mt={8} mb={4}>
          <Heading as='h5' size='sm' color='#64748b'>
            Transactions
          </Heading>
          <Link
            to='/transactions'
            style={{
              display: 'flex',
              alignItems: 'center',
              columnGap: '5px',
              color: '#2563eb',
              fontSize: '.9rem'
            }}
          >
            View all
            <ArrowRight boxSize='18px' />
          </Link>
        </Flex>

        {loading
          ? 'Loading...'
          : data?.subscriptions[0]?.subscription_payment_transactions.map(
              (transaction: any) => (
                <Transaction
                  key={transaction.id}
                  description={transaction?.product_item.name}
                  createdAt={transaction.created_at}
                  amount={transaction.amount}
                  type='debit'
                  border
                  id={transaction.id}
                />
              )
            )}
      </Container>
    </>
  );
};

const Progress = () => {
  return (
    <Box>
      <Box borderRadius='full' background='#fff' height={2.5} width='full' />
      <Box
        borderRadius='full'
        background='#172554'
        height={2.5}
        width='23%'
        mt={-2.5}
      />
    </Box>
  );
};

export default Root;
